import React, { useState } from 'react';
import { FaUniversity, FaChartLine, FaRupeeSign, FaBalanceScale, FaCoins, FaLandmark, FaBriefcase, FaUserTie, FaCheckCircle, FaBook, FaLaptop, FaClock, FaTrophy, FaChevronDown, FaChevronUp, FaCalculator, FaShieldAlt, FaHandHoldingUsd, FaFileInvoiceDollar, FaSeedling } from 'react-icons/fa';

const FinanceBankingEconomicsPage = () => {
  const [expandedOrg, setExpandedOrg] = useState(null);
  const [expandedExam, setExpandedExam] = useState(null);
  const [expandedRole, setExpandedRole] = useState(null);

  const organizations = [
    {
      id: 'rbi',
      name: 'RBI (Reserve Bank of India)',
      fullName: 'Reserve Bank of India',
      icon: <FaLandmark/>,
      established: '1935',
      type: 'Central Bank of India',
      headquarters: 'Mumbai',
      description: 'India\'s central banking institution that controls monetary policy',
      exams: [
        {
          name: 'RBI Grade B Officer',
          posts: ['General', 'DEPR (Economic Policy & Research)', 'DSIM (Statistics & Information Management)'],
          eligibility: 'Bachelor\'s Degree with minimum 60% (DEPR/DSIM: Post Graduate)',
          ageLimit: '21-30 years',
          salary: '₹77,000 - ₹1,00,000/month',
          grade: 'Grade B (Officer Scale I)',
          examPattern: [
            { phase: 'Phase I', duration: '120 minutes', sections: 'General Awareness (80 marks), English (30 marks), Quantitative Aptitude (30 marks), Reasoning (60 marks)', total: '200 marks' },
            { phase: 'Phase II', duration: '180 minutes', sections: 'Paper 1: Economic & Social Issues (100 marks), Paper 2: English (100 marks), Paper 3: Finance & Management (100 marks)', total: '300 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '50 marks' }
          ],
          syllabus: {
            economicSocialIssues: ['Indian Economy', 'Economic Reforms', 'Budget & Fiscal Policy', 'Money & Banking', 'International Trade', 'Social Development', 'Agriculture & Rural Development'],
            financeManagement: ['Financial Markets', 'Corporate Finance', 'Risk Management', 'Financial Statements', 'Banking Regulations', 'Forex Management', 'Capital Markets'],
            english: ['Essay Writing', 'Precis Writing', 'Comprehension', 'Letter Writing', 'Grammar']
          },
          responsibilities: ['Monetary policy formulation', 'Currency management', 'Banking supervision', 'Foreign exchange management', 'Economic research', 'Payment systems oversight'],
          careerPath: 'Grade B (Junior Manager) → Grade A (Assistant Manager) → Senior Manager → Chief Manager → Assistant General Manager → Deputy General Manager → General Manager → Executive Director'
        },
        {
          name: 'RBI Assistant',
          posts: ['Assistant (General)', 'Rajbhasha Adhikari'],
          eligibility: 'Bachelor\'s Degree',
          ageLimit: '20-28 years',
          salary: '₹35,000 - ₹50,000/month',
          grade: 'Assistant Cadre',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'English (30 marks), Quantitative Aptitude (35 marks), Reasoning (35 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '135 minutes', sections: 'Reasoning (60 marks), English (40 marks), Quantitative Aptitude (40 marks), General Awareness (40 marks), Computer (20 marks)', total: '200 marks' },
            { phase: 'Language Test', duration: '15 minutes', sections: 'Regional Language (25 marks)', total: '25 marks' }
          ],
          responsibilities: ['Office administration', 'Data management', 'Customer service', 'Documentation', 'Account maintenance'],
          careerPath: 'Assistant → Senior Assistant → Supervisor → Manager (through internal promotions)'
        },
        {
          name: 'RBI Office Attendant',
          posts: ['Office Attendant'],
          eligibility: '10th Pass',
          ageLimit: '18-25 years',
          salary: '₹18,000 - ₹30,000/month',
          grade: 'Sub-staff',
          examPattern: [
            { phase: 'Single Paper', duration: '120 minutes', sections: 'Reasoning (30 marks), Numerical Ability (30 marks), General Awareness (40 marks)', total: '100 marks' }
          ],
          responsibilities: ['Office support work', 'Housekeeping', 'Material handling', 'General assistance'],
          careerPath: 'Office Attendant → Senior Office Attendant'
        }
      ],
      departments: ['Monetary Policy', 'Banking Regulation', 'Foreign Exchange', 'Currency Management', 'Payment Systems', 'Financial Markets', 'Financial Inclusion', 'Legal', 'Human Resources'],
      benefits: ['Highest salary in banking sector', 'Prestigious work environment', 'Policy-making exposure', 'International opportunities', 'Excellent growth prospects']
    },
    {
      id: 'sebi',
      name: 'SEBI (Securities and Exchange Board of India)',
      fullName: 'Securities and Exchange Board of India',
      icon: <FaChartLine />,
      established: '1992',
      type: 'Market Regulator',
      headquarters: 'Mumbai',
      description: 'Regulatory body for securities and commodity markets in India',
      exams: [
        {
          name: 'SEBI Grade A (Assistant Manager)',
          posts: ['General Stream', 'Legal Stream', 'Information Technology Stream', 'Engineering Stream', 'Research Stream', 'Official Language Stream'],
          eligibility: 'Bachelor\'s Degree for General (Professional degree for specific streams)',
          ageLimit: '21-30 years',
          salary: '₹60,000 - ₹90,000/month',
          grade: 'Grade A (Officer)',
          examPattern: [
            { phase: 'Phase I', duration: '120 minutes', sections: 'General Awareness (25 marks), English (25 marks), Quantitative Aptitude (25 marks), Reasoning & Data Interpretation (25 marks)', total: '100 marks' },
            { phase: 'Phase II', duration: '120 minutes', sections: 'Paper 1: Securities Market (100 marks), Paper 2: Economic & Financial Analysis (100 marks), Paper 3: Commerce & Accountancy (100 marks)', total: '300 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '100 marks' }
          ],
          syllabus: {
            securitiesMarket: ['Capital Markets', 'Derivatives', 'Mutual Funds', 'IPOs', 'Market Regulations', 'SEBI Act', 'Investor Protection', 'Market Infrastructure'],
            economicAnalysis: ['Macroeconomics', 'Monetary Policy', 'Financial Markets', 'Public Finance', 'International Economics', 'Indian Economy'],
            commerceAccountancy: ['Financial Accounting', 'Cost Accounting', 'Financial Management', 'Corporate Law', 'Taxation', 'Auditing']
          },
          responsibilities: ['Market surveillance', 'Investor protection', 'Regulation enforcement', 'Policy formulation', 'Investigation of violations', 'Market development'],
          careerPath: 'Grade A (Assistant Manager) → Grade B (Deputy Manager) → Grade C (Assistant General Manager) → Grade D (Deputy General Manager) → Grade E (General Manager) → Grade F (Executive Director)'
        }
      ],
      departments: ['Market Regulation', 'Investment Management', 'Merchant Banking', 'Inspection', 'Enforcement', 'Legal Affairs', 'Information Technology', 'Economic Research'],
      benefits: ['Regulatory authority exposure', 'High reputation', 'Policy-making role', 'Market insight', 'Competitive salary']
    },
    {
      id: 'nabard',
      name: 'NABARD (National Bank for Agriculture and Rural Development)',
      fullName: 'National Bank for Agriculture and Rural Development',
      icon: <FaSeedling />,
      established: '1982',
      type: 'Development Bank',
      headquarters: 'Mumbai',
      description: 'Apex development bank for agriculture and rural development',
      exams: [
        {
          name: 'NABARD Grade A',
          posts: ['Assistant Manager (Grade A)', 'Manager (Grade B)'],
          eligibility: 'Bachelor\'s Degree (Agriculture/Commerce/Economics preferred)',
          ageLimit: '21-30 years',
          salary: '₹47,000 - ₹80,000/month',
          grade: 'Grade A',
          examPattern: [
            { phase: 'Preliminary', duration: '120 minutes', sections: 'Reasoning (40 marks), English (40 marks), Quantitative Aptitude (40 marks), General Awareness (40 marks), Computer (40 marks)', total: '200 marks' },
            { phase: 'Main Exam', duration: '180 minutes', sections: 'Paper 1: Economic & Social Issues (100 marks), Paper 2: Agriculture & Rural Development (100 marks), Paper 3: English (100 marks)', total: '300 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '25-50 marks' }
          ],
          syllabus: {
            agricultureRuralDev: ['Agriculture Production', 'Rural Development Schemes', 'Cooperatives', 'Microfinance', 'Rural Infrastructure', 'Watershed Management', 'SHG-Bank Linkage', 'Financial Inclusion'],
            economicSocialIssues: ['Indian Economy', 'Economic Reforms', 'Agriculture Economics', 'Rural Banking', 'Government Schemes', 'Sustainable Development'],
            generalAwareness: ['Current Affairs', 'Banking Awareness', 'Agriculture Current Affairs', 'Government Policies']
          },
          responsibilities: ['Agricultural credit management', 'Rural development schemes', 'Microfinance promotion', 'Refinance operations', 'Project appraisal', 'Capacity building'],
          careerPath: 'Grade B (Manager) → Grade A (Assistant Manager) → Chief Manager → Assistant General Manager → Deputy General Manager → General Manager'
        },
        {
          name: 'NABARD Development Assistant',
          posts: ['Office Assistant', 'Development Assistant'],
          eligibility: 'Bachelor\'s Degree',
          ageLimit: '18-28 years',
          salary: '₹25,000 - ₹45,000/month',
          grade: 'Support Staff',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'Reasoning (40 marks), English (40 marks), Quantitative Aptitude (40 marks)', total: '120 marks' },
            { phase: 'Main Exam', duration: '120 minutes', sections: 'Agriculture & Rural Development (40 marks), Reasoning (40 marks), English (40 marks), Computer (40 marks), General Awareness (40 marks)', total: '200 marks' }
          ],
          responsibilities: ['Office support', 'Data entry', 'Documentation', 'Correspondence', 'Field work support'],
          careerPath: 'Development Assistant → Senior Assistant → Supervisor'
        }
      ],
      departments: ['Agricultural Credit', 'Microfinance', 'Rural Infrastructure', 'Watershed Development', 'Farm Sector', 'Non-Farm Sector', 'Inspection', 'Training'],
      benefits: ['Rural development focus', 'Field exposure', 'Social impact', 'Stable career', 'Good work-life balance']
    },
    {
      id: 'ibps',
      name: 'IBPS (Institute of Banking Personnel Selection)',
      fullName: 'Institute of Banking Personnel Selection',
      icon: <FaUniversity />,
      established: '1975',
      type: 'Recruitment Body',
      headquarters: 'Mumbai',
      description: 'Conducts common written examinations for recruitment in 12 Public Sector Banks',
      exams: [
        {
          name: 'IBPS PO (Probationary Officer)',
          posts: ['Probationary Officer/Management Trainee'],
          eligibility: 'Bachelor\'s Degree (Any discipline)',
          ageLimit: '20-30 years',
          salary: '₹40,000 - ₹60,000/month',
          grade: 'Officer Scale I (JMGS-I)',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'English (30 marks), Quantitative Aptitude (35 marks), Reasoning (35 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '180 minutes', sections: 'Reasoning (60 marks), English (40 marks), Data Analysis (60 marks), General Awareness (40 marks), Computer (20 marks), Descriptive (25 marks)', total: '245 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '100 marks' }
          ],
          syllabus: {
            reasoning: ['Puzzles', 'Seating Arrangement', 'Syllogism', 'Blood Relations', 'Coding-Decoding', 'Direction', 'Inequality', 'Data Sufficiency'],
            quantitativeAptitude: ['Number Series', 'Simplification', 'Data Interpretation', 'Quadratic Equations', 'Time & Work', 'Percentage', 'Profit & Loss', 'SI & CI'],
            english: ['Reading Comprehension', 'Cloze Test', 'Error Spotting', 'Para Jumbles', 'Sentence Improvement', 'Vocabulary'],
            generalAwareness: ['Banking Awareness', 'Current Affairs', 'Static GK', 'Financial Awareness', 'Government Schemes']
          },
          responsibilities: ['Branch operations', 'Customer service', 'Loan processing', 'Team management', 'Business development', 'Risk management'],
          careerPath: 'PO (JMGS-I) → MMGS-II → MMGS-III → SMGS-IV → SMGS-V → TEGS-VI → TEGS-VII'
        },
        {
          name: 'IBPS Clerk',
          posts: ['Clerical Cadre'],
          eligibility: 'Bachelor\'s Degree',
          ageLimit: '20-28 years',
          salary: '₹20,000 - ₹30,000/month',
          grade: 'Clerical Cadre',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'English (30 marks), Quantitative Aptitude (35 marks), Reasoning (35 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '160 minutes', sections: 'Reasoning (50 marks), English (40 marks), Quantitative Aptitude (50 marks), General Awareness (40 marks), Computer (20 marks)', total: '200 marks' }
          ],
          responsibilities: ['Cash handling', 'Customer service', 'Account opening', 'Passbook printing', 'Data entry', 'Documentation'],
          careerPath: 'Clerk → Senior Clerk → Chief Clerk → Promotion to Officer Cadre'
        },
        {
          name: 'IBPS SO (Specialist Officer)',
          posts: ['IT Officer', 'Agricultural Field Officer', 'Rajbhasha Adhikari', 'Law Officer', 'HR/Personnel Officer', 'Marketing Officer'],
          eligibility: 'Specific degree as per post (B.E./B.Tech for IT, B.Sc. Agriculture, LLB, MBA, etc.)',
          ageLimit: '20-30 years',
          salary: '₹30,000 - ₹70,000/month',
          grade: 'Officer Scale I to III',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'Reasoning (50 marks), English (25 marks), Quantitative Aptitude (25 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '120 minutes', sections: 'Professional Knowledge (60 marks), General Awareness (40 marks), Reasoning (50 marks), English (25 marks), Quantitative Aptitude (25 marks)', total: '200 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '100 marks' }
          ],
          specializations: {
            itOfficer: ['Programming Languages', 'DBMS', 'Networking', 'Cyber Security', 'Operating Systems', 'Web Technologies'],
            lawOfficer: ['Banking Laws', 'Negotiable Instruments Act', 'SARFAESI Act', 'IBC Code', 'Contract Law', 'Banking Regulations'],
            agricultureOfficer: ['Agriculture Production', 'Crop Science', 'Horticulture', 'Agricultural Finance', 'Government Schemes'],
            hrOfficer: ['HR Management', 'Industrial Relations', 'Recruitment', 'Training & Development', 'Performance Management']
          },
          responsibilities: ['Domain-specific work', 'Technical support', 'Advisory role', 'Project management', 'Specialized services'],
          careerPath: 'SO Scale I → Scale II → Scale III → MMGS → SMGS'
        },
        {
          name: 'IBPS RRB (Regional Rural Banks)',
          posts: ['Officer Scale I, II, III', 'Office Assistant'],
          eligibility: 'Bachelor\'s Degree (Graduate/Post Graduate for Scale II/III)',
          ageLimit: '18-30 years',
          salary: '₹20,000 - ₹45,000/month',
          grade: 'Scale I to III',
          examPattern: [
            { phase: 'Preliminary', duration: '45 minutes', sections: 'Reasoning (40 marks), Quantitative Aptitude (40 marks)', total: '80 marks' },
            { phase: 'Main Exam', duration: '120 minutes', sections: 'Reasoning (40 marks), Quantitative Aptitude (40 marks), General Awareness (40 marks), English/Hindi (40 marks), Computer (40 marks)', total: '200 marks' }
          ],
          responsibilities: ['Rural banking operations', 'Agricultural loans', 'Customer service', 'Branch management', 'Financial inclusion'],
          careerPath: 'Officer Scale I → Scale II → Scale III → Senior Management'
        }
      ],
      recruitingBanks: ['Punjab National Bank', 'Bank of Baroda', 'Canara Bank', 'Union Bank of India', 'Bank of India', 'Indian Bank', 'Central Bank of India', 'Indian Overseas Bank', 'UCO Bank', 'Bank of Maharashtra', 'Punjab & Sind Bank'],
      benefits: ['Multiple bank options', 'Pan-India postings', 'Job security', 'Good salary', 'Career growth']
    },
    {
      id: 'sbi',
      name: 'SBI (State Bank of India)',
      fullName: 'State Bank of India',
      icon: <FaUniversity />,
      established: '1955',
      type: 'Public Sector Bank',
      headquarters: 'Mumbai',
      description: 'India\'s largest public sector bank with global presence',
      exams: [
        {
          name: 'SBI PO (Probationary Officer)',
          posts: ['Probationary Officer'],
          eligibility: 'Bachelor\'s Degree (Any discipline)',
          ageLimit: '21-30 years',
          salary: '₹50,000 - ₹70,000/month',
          grade: 'JMGS-I (Junior Management Grade Scale I)',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'English (30 marks), Quantitative Aptitude (35 marks), Reasoning (35 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '180 minutes', sections: 'Reasoning (60 marks), Data Analysis (60 marks), General Awareness (40 marks), English (40 marks), Computer (20 marks), Descriptive (50 marks)', total: '270 marks' },
            { phase: 'Group Exercise', duration: 'Varies', sections: 'Group Discussion', total: '20 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '30 marks' }
          ],
          syllabus: {
            reasoning: ['Puzzles', 'Seating Arrangement', 'Blood Relations', 'Direction', 'Coding-Decoding', 'Syllogism', 'Inequality'],
            dataAnalysis: ['Data Interpretation', 'Graphs & Charts', 'Tables', 'Case Studies', 'Number Series'],
            generalAwareness: ['Current Affairs', 'Banking Awareness', 'Economic & Financial Awareness', 'Static GK', 'Government Schemes'],
            descriptive: ['Essay Writing', 'Letter Writing', 'Precis Writing']
          },
          responsibilities: ['Branch operations management', 'Customer relationship', 'Loan processing', 'Team leadership', 'Business development', 'Policy implementation'],
          careerPath: 'PO → Manager → Chief Manager → Assistant General Manager → Deputy General Manager → General Manager → Managing Director'
        },
        {
          name: 'SBI Clerk (Junior Associate)',
          posts: ['Junior Associate (Customer Support & Sales)'],
          eligibility: 'Bachelor\'s Degree',
          ageLimit: '20-28 years',
          salary: '₹25,000 - ₹35,000/month',
          grade: 'Clerical Cadre',
          examPattern: [
            { phase: 'Preliminary', duration: '60 minutes', sections: 'English (30 marks), Quantitative Aptitude (35 marks), Reasoning (35 marks)', total: '100 marks' },
            { phase: 'Main Exam', duration: '160 minutes', sections: 'General English (40 marks), Quantitative Aptitude (50 marks), Reasoning (50 marks), General Awareness (40 marks), Computer (20 marks)', total: '200 marks' },
            { phase: 'Language Test', duration: '15 minutes', sections: 'Regional Language', total: 'Qualifying' }
          ],
          responsibilities: ['Customer service at counter', 'Cash handling', 'Account maintenance', 'Data entry', 'Passbook printing', 'Cheque processing'],
          careerPath: 'Clerk → Senior Clerk → Chief Clerk → Internal promotion to Officer Cadre'
        },
        {
          name: 'SBI SO (Specialist Officer)',
          posts: ['IT Officer (System)', 'IT Officer (Infrastructure)', 'CA/CMA', 'Chartered Accountant', 'Economist', 'Agriculture Field Officer', 'Law Officer', 'Manager (Risk)', 'Manager (Forex)'],
          eligibility: 'Specific professional degree/qualification',
          ageLimit: '21-35 years',
          salary: '₹32,000 - ₹75,000/month',
          grade: 'JMGS-I to MMGS-III',
          examPattern: [
            { phase: 'Objective Test', duration: '120 minutes', sections: 'Professional Knowledge (50 marks), English (25 marks), Reasoning (25 marks), Quantitative Aptitude (25 marks), General Awareness (25 marks)', total: '150 marks' },
            { phase: 'Descriptive Test', duration: '30 minutes', sections: 'Professional Knowledge (50 marks)', total: '50 marks' },
            { phase: 'Interview', duration: 'Varies', sections: 'Personal Interview', total: '50 marks' }
          ],
          specializations: {
            itOfficerSystem: ['Software Development', 'Database Management', 'Application Development', 'System Analysis', 'Programming'],
            ca: ['Financial Accounting', 'Taxation', 'Auditing', 'Cost Analysis', 'Financial Management'],
            economist: ['Economic Analysis', 'Policy Research', 'Statistical Analysis', 'Economic Forecasting'],
            lawOfficer: ['Banking Laws', 'Corporate Law', 'Cyber Law', 'Contract Law', 'Legal Documentation']
          },
          responsibilities: ['Domain expertise', 'Technical advisory', 'Specialized operations', 'Risk management', 'Legal compliance'],
          careerPath: 'SO JMGS-I → MMGS-II → MMGS-III → SMGS-IV → Senior Management'
        }
      ],
      branches: '22,000+ branches across India',
      international: 'Presence in 36 countries',
      benefits: ['Largest PSB in India', 'International exposure', 'Best-in-class facilities', 'Career growth', 'Job security']
    }
  ];

  const comparativeAnalysis = [
    {
      exam: 'RBI Grade B',
      salary: '₹77,000 - ₹1,00,000',
      prestige: 'Highest',
      difficulty: 'Very High',
      competition: 'Very Tough',
      workLife: 'Excellent',
      growth: 'Fast Track'
    },
    {
      exam: 'SEBI Grade A',
      salary: '₹60,000 - ₹90,000',
      prestige: 'Very High',
      difficulty: 'High',
      competition: 'Tough',
      workLife: 'Very Good',
      growth: 'Fast'
    },
    {
      exam: 'NABARD Grade A',
      salary: '₹47,000 - ₹80,000',
      prestige: 'High',
      difficulty: 'Moderate-High',
      competition: 'Moderate',
      workLife: 'Very Good',
      growth: 'Good'
    },
    {
      exam: 'SBI PO',
      salary: '₹50,000 - ₹70,000',
      prestige: 'High',
      difficulty: 'Moderate-High',
      competition: 'High',
      workLife: 'Good',
      growth: 'Good'
    },
    {
      exam: 'IBPS PO',
      salary: '₹40,000 - ₹60,000',
      prestige: 'Good',
      difficulty: 'Moderate',
      competition: 'Moderate-High',
      workLife: 'Good',
      growth: 'Steady'
    },
    {
      exam: 'SBI Clerk',
      salary: '₹25,000 - ₹35,000',
      prestige: 'Moderate',
      difficulty: 'Moderate',
      competition: 'High',
      workLife: 'Good',
      growth: 'Steady'
    },
    {
      exam: 'IBPS Clerk',
      salary: '₹20,000 - ₹30,000',
      prestige: 'Moderate',
      difficulty: 'Moderate',
      competition: 'High',
      workLife: 'Good',
      growth: 'Steady'
    }
  ];

  const preparationRoadmap = [
    {
      phase: 'Foundation Building (3 months)',
      focus: 'Concept clarity and basics',
      activities: [
        'Complete syllabus coverage',
        'Understand banking basics',
        'Learn quantitative aptitude fundamentals',
        'Build reasoning skills',
        'English grammar and vocabulary',
        'Start newspaper reading'
      ]
    },
    {
      phase: 'Practice Phase (3-4 months)',
      focus: 'Speed and accuracy',
      activities: [
        'Topic-wise practice',
        'Previous year question papers',
        'Shortcut techniques',
        'Banking awareness compilation',
        'Current affairs notes',
        'Sectional mock tests'
      ]
    },
    {
      phase: 'Mock Test Phase (2-3 months)',
      focus: 'Exam simulation',
      activities: [
        'Full-length mock tests',
        'Time management practice',
        'Attempt strategy development',
        'Error analysis',
        'Weak area improvement',
        'Interview preparation'
      ]
    },
    {
      phase: 'Final Revision (1 month)',
      focus: 'Consolidation',
      activities: [
        'Formula sheets revision',
        'Current affairs last 6 months',
        'Banking awareness revision',
        'Mock tests analysis',
        'Descriptive writing practice',
        'Confidence building'
      ]
    }
  ];

  const careerBenefits = [
    'Excellent salary packages with regular increments',
    'Job security and stability',
    'Government employee status (PSBs)',
    'Medical insurance for self and family',
    'Housing loan at subsidized rates',
    'Leave Travel Allowance (LTA)',
    'Dearness Allowance (DA)',
    'House Rent Allowance (HRA)',
    'Pension benefits (7th Pay Commission)',
    'Performance-based incentives',
    'Work-life balance',
    'Prestigious career',
    'Career growth opportunities',
    'Transfer options across India',
    'Training and skill development',
    'International posting opportunities (SBI, RBI)'
  ];

  const features = [
    {
      icon: <FaBook />,
      title: 'Expert Faculty',
      description: 'Learn from experienced banking professionals and exam toppers'
    },
    {
      icon: <FaLaptop />,
      title: 'Online Test Platform',
      description: 'Unlimited mock tests with advanced analytics and performance tracking'
    },
    {
      icon: <FaCalculator />,
      title: 'Shortcut Techniques',
      description: 'Master time-saving methods for quantitative aptitude'
    },
    {
      icon: <FaClock />,
      title: 'Time Management',
      description: 'Develop strategies to maximize your score in limited time'
    },
    {
      icon: <FaChartLine />,
      title: 'Current Affairs',
      description: 'Daily updates and monthly compilations of banking and general awareness'
    },
    {
      icon: <FaTrophy />,
      title: 'Interview Training',
      description: 'Mock interviews and GD practice for RBI, SEBI, NABARD exams'
    }
  ];

  const toggleOrg = (id) => {
    setExpandedOrg(expandedOrg === id ? null : id);
  };

  const toggleExam = (id) => {
    setExpandedExam(expandedExam === id ? null : id);
  };

  const toggleRole = (id) => {
    setExpandedRole(expandedRole === id ? null : id);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Hero Section */}
      <div className="text-white py-5 my-5" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h1 className="display-4 fw-bold mb-3">Finance, Banking & Economics Sector</h1>
              <p className="lead mb-4">
                Comprehensive training for RBI, SEBI, NABARD, IBPS, and SBI examinations. Build your career in India's premier financial institutions with excellent salary, job security, and growth opportunities.
              </p>
              <button className="btn btn-light btn-lg px-4 me-3">Start Preparation</button>
              <button className="btn btn-outline-light btn-lg px-4">View All Courses</button>
            </div>
            <div className="col-lg-4 text-center">
              <FaUniversity size={150} className="opacity-75" />
            </div>
          </div>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="container py-4">
        <div className="row g-4 col-9 mx-auto">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-primary fw-bold mb-1">1 Lakh+</h3>
              <p className="text-muted mb-0">Annual Vacancies</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-success fw-bold mb-1">₹20K-1L</h3>
              <p className="text-muted mb-0">Salary Range/Month</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-info fw-bold mb-1">15+ Banks</h3>
              <p className="text-muted mb-0">Recruiting</p>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center p-3">
              <h3 className="text-warning fw-bold mb-1">Graduate</h3>
              <p className="text-muted mb-0">Minimum Qualification</p>
            </div>
          </div>
        </div>
      </div>

      {/* Organizations & Exams */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Financial Institutions & Their Examinations</h2>
        <div className="row">
          <div className="col-9 mx-auto">
            {organizations.map((org) => (
              <div key={org.id} className="card mb-3 border-0 shadow-sm">
                <div 
                  className="card-header bg-light d-flex justify-content-between align-items-center"
                  onClick={() => toggleOrg(org.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <div className="text-primary me-3" style={{ fontSize: '2rem' }}>
                      {org.icon}
                    </div>
                    <div>
                      <h5 className="mb-1 fw-bold text-primary">{org.name}</h5>
                      <small className="text-muted">{org.fullName} • Established: {org.established}</small>
                    </div>
                  </div>
                  {expandedOrg === org.id ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {expandedOrg === org.id && (
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <p className="mb-2"><strong>Type:</strong> {org.type}</p>
                        <p className="mb-2"><strong>Headquarters:</strong> {org.headquarters}</p>
                        <p className="mb-2"><strong>Description:</strong> {org.description}</p>
                      </div>
                      <div className="col-md-6">
                        {org.recruitingBanks && (
                          <div>
                            <p className="mb-2"><strong>Recruiting Banks:</strong></p>
                            <small className="text-muted">Conducts exams for 12 Public Sector Banks</small>
                          </div>
                        )}
                        {org.branches && (
                          <p className="mb-2"><strong>Network:</strong> {org.branches}</p>
                        )}
                        {org.international && (
                          <p className="mb-2"><strong>International:</strong> {org.international}</p>
                        )}
                      </div>
                    </div>

                    <h6 className="fw-bold mb-3">Examinations Conducted:</h6>
                    {org.exams.map((exam, idx) => (
                      <div key={idx} className="card mb-3 border-light">
                        <div 
                          className="card-header bg-white d-flex justify-content-between align-items-center"
                          onClick={() => toggleExam(`${org.id}-${idx}`)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div>
                            <h6 className="text-primary fw-bold mb-1">{exam.name}</h6>
                            <small className="text-muted">Grade: {exam.grade} | Salary: {exam.salary}</small>
                          </div>
                          {expandedExam === `${org.id}-${idx}` ? <FaChevronUp /> : <FaChevronDown />}
                        </div>
                        {expandedExam === `${org.id}-${idx}` && (
                          <div className="card-body">
                            <div className="row mb-4">
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Eligibility:</strong></p>
                                <p className="small text-muted">{exam.eligibility}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Age Limit:</strong></p>
                                <p className="small text-muted">{exam.ageLimit}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Salary:</strong></p>
                                <p className="small text-success fw-bold">{exam.salary}</p>
                              </div>
                              <div className="col-md-3">
                                <p className="small mb-1"><strong>Grade:</strong></p>
                                <p className="small text-info">{exam.grade}</p>
                              </div>
                            </div>

                            {exam.posts && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-2">Available Posts:</h6>
                                <div className="d-flex flex-wrap gap-2">
                                  {exam.posts.map((post, pIdx) => (
                                    <span key={pIdx} className="badge bg-info">{post}</span>
                                  ))}
                                </div>
                              </div>
                            )}

                            <h6 className="fw-bold mb-3">Examination Pattern:</h6>
                            <div className="table-responsive">
                              <table className="table table-sm table-bordered">
                                <thead className="table-light">
                                  <tr>
                                    <th>Phase</th>
                                    <th>Duration</th>
                                    <th>Sections</th>
                                    <th>Total Marks</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {exam.examPattern.map((pattern, pIdx) => (
                                    <tr key={pIdx}>
                                      <td className="fw-semibold">{pattern.phase}</td>
                                      <td>{pattern.duration}</td>
                                      <td><small>{pattern.sections}</small></td>
                                      <td className="text-success">{pattern.total}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            {exam.syllabus && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-3">Syllabus Highlights:</h6>
                                <div className="row">
                                  {Object.entries(exam.syllabus).map(([key, topics], sIdx) => (
                                    <div key={sIdx} className="col-md-6 mb-3">
                                      <div className="card border-0 bg-light">
                                        <div className="card-body p-3">
                                          <h6 className="text-primary mb-2">{key.replace(/([A-Z])/g, ' $1').trim().toUpperCase()}</h6>
                                          <div className="d-flex flex-wrap gap-1">
                                            {Array.isArray(topics) ? topics.map((topic, tIdx) => (
                                              <span key={tIdx} className="badge bg-secondary small">{topic}</span>
                                            )) : <p className="small mb-0">{topics}</p>}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {exam.specializations && (
                              <div className="mb-4">
                                <h6 className="fw-bold mb-3">Specialization Syllabus:</h6>
                                <div className="row">
                                  {Object.entries(exam.specializations).map(([key, topics], sIdx) => (
                                    <div key={sIdx} className="col-md-6 mb-2">
                                      <div className="card border-0 bg-light">
                                        <div className="card-body p-3">
                                          <h6 className="text-info mb-2">{key.replace(/([A-Z])/g, ' $1').trim()}</h6>
                                          <div className="d-flex flex-wrap gap-1">
                                            {topics.map((topic, tIdx) => (
                                              <span key={tIdx} className="badge bg-secondary small">{topic}</span>
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            <div className="mb-3">
                              <h6 className="fw-bold mb-2">Key Responsibilities:</h6>
                              <div className="row">
                                {exam.responsibilities.map((resp, rIdx) => (
                                  <div key={rIdx} className="col-md-6 mb-2">
                                    <FaCheckCircle className="text-success me-2" size={12} />
                                    <small>{resp}</small>
                                  </div>
                                ))}
                              </div>
                            </div>

                            <div className="alert alert-info mb-0">
                              <strong>Career Path:</strong> {exam.careerPath}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    {org.departments && (
                      <div className="mt-4">
                        <h6 className="fw-bold mb-2">Departments:</h6>
                        <div className="d-flex flex-wrap gap-2">
                          {org.departments.map((dept, dIdx) => (
                            <span key={dIdx} className="badge bg-secondary">{dept}</span>
                          ))}
                        </div>
                      </div>
                    )}

                    {org.benefits && (
                      <div className="mt-4">
                        <h6 className="fw-bold mb-2">Why Join?</h6>
                        <div className="row">
                          {org.benefits.map((benefit, bIdx) => (
                            <div key={bIdx} className="col-md-6 mb-2">
                              <FaCheckCircle className="text-success me-2" size={12} />
                              <small>{benefit}</small>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Comparative Analysis */}
      <div className="bg-white py-5">
        <div className="container col-11 mx-auto">
          <h2 className="text-center mb-5 fw-bold">Exam Comparison Matrix</h2>
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>Exam</th>
                  <th>Salary</th>
                  <th>Prestige</th>
                  <th>Difficulty</th>
                  <th>Competition</th>
                  <th>Work-Life Balance</th>
                  <th>Career Growth</th>
                </tr>
              </thead>
              <tbody>
                {comparativeAnalysis.map((exam, idx) => (
                  <tr key={idx}>
                    <td className="fw-bold">{exam.exam}</td>
                    <td className="text-success">{exam.salary}</td>
                    <td>
                      <span className={`badge ${
                        exam.prestige === 'Highest' ? 'bg-danger' :
                        exam.prestige === 'Very High' ? 'bg-warning' :
                        exam.prestige === 'High' ? 'bg-info' :
                        exam.prestige === 'Good' ? 'bg-primary' : 'bg-secondary'
                      }`}>{exam.prestige}</span>
                    </td>
                    <td>{exam.difficulty}</td>
                    <td>{exam.competition}</td>
                    <td>{exam.workLife}</td>
                    <td>{exam.growth}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Preparation Roadmap */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">12-Month Preparation Roadmap</h2>
        <div className="row g-4">
          {preparationRoadmap.map((phase, idx) => (
            <div key={idx} className="col-md-3">
              <div className="card border-0 shadow h-100">
                <div className="card-header bg-gradient text-dark" style={{ background: `linear-gradient(135deg, ${['#667eea', '#f093fb', '#4facfe', '#43e97b'][idx]} 0%, ${['#764ba2', '#f5576c', '#00f2fe', '#38f9d7'][idx]} 100%)` }}>
                  <h5 className="mb-1 fw-bold">{phase.phase}</h5>
                  <small>Focus: {phase.focus}</small>
                </div>
                <div className="card-body">
                  <h6 className="fw-bold mb-3">Key Activities:</h6>
                  <ul className="list-unstyled">
                    {phase.activities.map((activity, aIdx) => (
                      <li key={aIdx} className="mb-2">
                        <FaCheckCircle className="text-success me-2" />
                        {activity}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Career Benefits */}
      <div className="bg-light py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Career Benefits in Banking & Finance Sector</h2>
          <div className="row g-3 col-11 mx-auto">
            {careerBenefits.map((benefit, idx) => (
              <div key={idx} className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-body d-flex align-items-center p-3">
                    <FaCheckCircle className="text-success me-3 flex-shrink-0" size={20} />
                    <p className="mb-0">{benefit}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Subject-wise Preparation */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Subject-wise Preparation Strategy</h2>
        <div className="row g-4 col-9 mx-auto">
          <div className="col-md-6">
            <div className="card border-primary h-100">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">Quantitative Aptitude</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Master Basics:</strong> Clear concepts of arithmetic, algebra, and data interpretation
                  </li>
                  <li className="mb-3">
                    <strong>Shortcut Techniques:</strong> Learn time-saving methods for calculations
                  </li>
                  <li className="mb-3">
                    <strong>Daily Practice:</strong> Solve at least 50 questions daily
                  </li>
                  <li className="mb-3">
                    <strong>Data Interpretation:</strong> Focus heavily on graphs, charts, and tables
                  </li>
                  <li className="mb-3">
                    <strong>Speed Tests:</strong> Practice with timer to improve speed
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-success h-100">
              <div className="card-header bg-success text-white">
                <h5 className="mb-0">Reasoning Ability</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Puzzles:</strong> Master seating arrangement and scheduling puzzles
                  </li>
                  <li className="mb-3">
                    <strong>Syllogism:</strong> Learn all possible conclusion patterns
                  </li>
                  <li className="mb-3">
                    <strong>Coding-Decoding:</strong> Practice various types regularly
                  </li>
                  <li className="mb-3">
                    <strong>Blood Relations:</strong> Draw family trees for complex problems
                  </li>
                  <li className="mb-3">
                    <strong>Mock Tests:</strong> Take topic-wise tests for improvement
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-info h-100">
              <div className="card-header bg-info text-white">
                <h5 className="mb-0">English Language</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Reading Comprehension:</strong> Read editorials and practice RC passages daily
                  </li>
                  <li className="mb-3">
                    <strong>Vocabulary:</strong> Learn 20 new words daily with usage
                  </li>
                  <li className="mb-3">
                    <strong>Grammar:</strong> Master tenses, voices, and sentence correction
                  </li>
                  <li className="mb-3">
                    <strong>Descriptive:</strong> Practice essay and letter writing weekly
                  </li>
                  <li className="mb-3">
                    <strong>Error Spotting:</strong> Understand common grammar mistakes
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card border-warning h-100">
              <div className="card-header bg-warning text-dark">
                <h5 className="mb-0">General Awareness</h5>
              </div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li className="mb-3">
                    <strong>Current Affairs:</strong> Read newspapers daily (The Hindu/Economic Times)
                  </li>
                  <li className="mb-3">
                    <strong>Banking Awareness:</strong> Follow RBI policies and banking news
                  </li>
                  <li className="mb-3">
                    <strong>Static GK:</strong> Prepare state capitals, currencies, headquarters
                  </li>
                  <li className="mb-3">
                    <strong>Government Schemes:</strong> Stay updated with all major schemes
                  </li>
                  <li className="mb-3">
                    <strong>Monthly Compilation:</strong> Prepare monthly CA notes
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <div className="bg-white py-5">
        <div className="container">
          <h2 className="text-center mb-5 fw-bold">Why Choose Our Training?</h2>
          <div className="row g-4 col-9 mx-auto">
            {features.map((feature, idx) => (
              <div key={idx} className="col-md-4">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="text-primary mb-3" style={{ fontSize: '3rem' }}>
                    {feature.icon}
                  </div>
                  <h5 className="fw-bold mb-3">{feature.title}</h5>
                  <p className="text-muted">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Success Tips */}
      <div className="container py-5">
        <h2 className="text-center mb-5 fw-bold">Success Mantras for Banking Exams</h2>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">1</h3>
              </div>
              <h5 className="fw-bold mb-3">Consistency is Key</h5>
              <p className="text-muted">Study for 4-6 hours daily with breaks. Consistency beats intensity.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-success text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">2</h3>
              </div>
              <h5 className="fw-bold mb-3">Practice Makes Perfect</h5>
              <p className="text-muted">Take minimum 50+ mock tests before the actual exam.</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow text-center p-4">
              <div className="bg-info text-white rounded-circle d-inline-flex align-items-center justify-content-center mx-auto mb-3" style={{ width: '60px', height: '60px' }}>
                <h3 className="mb-0">3</h3>
              </div>
              <h5 className="fw-bold mb-3">Smart Attempt</h5>
              <p className="text-muted">Attempt questions you're confident about. Avoid negative marking.</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container py-5">
        <div className="card border-0 shadow-lg" style={{ background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)' }}>
          <div className="card-body text-white text-center p-5">
            <h2 className="fw-bold mb-3">Ready to Join the Banking & Finance Sector?</h2>
            <p className="lead mb-4">
              Start your preparation today with our comprehensive training for all banking exams
            </p>
            <button className="btn btn-light btn-lg px-5 me-3">Enroll Now</button>
            <button className="btn btn-outline-light btn-lg px-5">Book Free Demo Class</button>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="container py-4">
        <div className="text-center bg-danger-subtle text-muted">
          <small className='fs-5' >
            All information is indicative and subject to change. Please verify from official sources before making decisions.
          </small>
        </div>
      </div>
    </div>
  );
};

export default FinanceBankingEconomicsPage;